import { faLineColumns } from '@fortawesome/pro-duotone-svg-icons';
import { faMicrochipAi } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ColumnSelectionOverlay from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpView/IngredientProductMappingComponent/ColumnSelectionOverlay';
import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import Overlay from 'components/desktop/_general/Overlay/Overlay';

export type IProps = RecipeErpViewComponentProps;

const IngredientListComponentButtons = (props: IProps) => {
	const [displayOverlay, setDisplayOverlay] = useState<boolean>(false);
	const { t } = useTranslation();

	return (
		<>
			<Overlay
				displayOverlay={displayOverlay}
				handleClose={() => setDisplayOverlay(false)}
				containerStyle={{ minWidth: '40%' }}
			>
				<ColumnSelectionOverlay
					selectedColumns={props.state.selectedColumns}
					setSelectedColumns={props.handlers.setSelectedColumns}
					close={() => setDisplayOverlay(false)}
				/>
			</Overlay>

			<div className="d-flex justify-content-between" style={{ marginBottom: '10px' }}>
				<button
					type="button"
					className="btn btn-sm btn-outline-primary"
					onClick={() => setDisplayOverlay(true)}
				>
					<FontAwesomeIcon icon={faLineColumns} style={{ marginRight: '7px' }} />
					{t('_general:COLUMNS')}
				</button>
				<button
					type="button"
					className="btn btn-outline-primary btn-sm"
					onClick={props.handlers.mapFirstSuggestionToProduct}
				>
					<FontAwesomeIcon
						icon={faMicrochipAi}
						size="lg"
						style={{ marginRight: '7px' }}
					/>
					{t('menuPlan:GENERATE')}
				</button>
			</div>
		</>
	);
};

export default IngredientListComponentButtons;
